var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 0.5H5.75008C4.92283 0.5 4.25008 1.17275 4.25008 2V6.1895L0.719834 9.71975C0.614977 9.82464 0.543572 9.95826 0.514647 10.1037C0.485721 10.2492 0.500573 10.4 0.557326 10.537C0.614078 10.674 0.710183 10.7911 0.83349 10.8736C0.956798 10.956 1.10177 11 1.25008 11V14.75C1.25008 14.9489 1.3291 15.1397 1.46975 15.2803C1.61041 15.421 1.80117 15.5 2.00008 15.5H14.0001C14.199 15.5 14.3898 15.421 14.5304 15.2803C14.6711 15.1397 14.7501 14.9489 14.7501 14.75V2C14.7501 1.17275 14.0773 0.5 13.2501 0.5ZM7.25008 14H2.75008V9.8105L5.00008 7.5605L7.25008 9.8105V14ZM13.2501 14H8.75008V11C8.89856 11.0003 9.04378 10.9565 9.16732 10.8742C9.29086 10.7918 9.38715 10.6746 9.44397 10.5375C9.50078 10.4003 9.51556 10.2493 9.48642 10.1037C9.45729 9.95815 9.38556 9.8245 9.28033 9.71975L5.75008 6.1895V2H13.2501V14Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 3.5H8.75V5H7.25V3.5ZM10.25 3.5H11.75V5H10.25V3.5ZM10.25 6.52325H11.75V8H10.25V6.52325ZM10.25 9.5H11.75V11H10.25V9.5ZM4.25 10.25H5.75V11.75H4.25V10.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.30d79e0b6f022ab84f1298099c6a5a7e.svg";
export { ForwardRef as ReactComponent };